
export enum SubscriptionTypes {
    PII = 'pii',
    PROD = "prod",
    DDoS = "DDoS",
    AWS_NON_PROD_PII = "pii",
    AWS_PROD_PII = "prod",
    NON_PROD = "NON_PROD",
    NEW_PII = "NEW_PII",
    PROD_IDENTITY = "PROD_IDENTITY",
    NON_PII = 'NON-PII',
    AWS_NON_PII = 'NONPII',
    AWS_NONPROD_PII = 'NONPROD_PII',
    PROD_PII = 'PROD_PII',
    TEST = 'TEST',
    SANDBOX = 'SANDBOX',
    NONPII = 'nonpii'
}
